import React from 'react';
import { LFC } from '../../../Legacy';
import { Icon } from '../../../concepts/resources/Icon';
import { usePrompt } from '../../../ui';
import { Popup, PopupProps } from '../../popups/Popup';
import { Flexer } from '../elements/LayoutElements';
import { SelectTasksView } from './SelectTasksView';

export const importTasksPopup = () => ({ ui: ImportTasksPopup });

export const ImportTasksPopup: LFC<PopupProps> = ({ action, dismiss, args }) => {

    const promptRef = usePrompt({
        ignoreEnter: true,
        onAction: dismiss,
    });

    return <Popup w="100" h="80%" ref={promptRef} p="1">
        <Popup.Header>
            <Popup.IconFrame>
                <Icon src="deqo://icons/dash/actions" size="2" />
            </Popup.IconFrame>
            <Popup.Title>
                Import: Action Items
            </Popup.Title>
            <Popup.SubTitle>
                Bring your action items into your board!
            </Popup.SubTitle>
        </Popup.Header>
        <Popup.Content>
            <Flexer height="1" />
            <SelectTasksView onSelect={action} />
        </Popup.Content>
        <Popup.Close onAction={dismiss} />
    </Popup>;
};
